import Logo from '../../../assets/images/trvto-logo.png';
import { FormContent } from '../../../components/bookingConfirmationCard/bookingConfirmationFun';
import { toast } from 'react-toastify';
import { ReactComponent as Copy } from '../../../assets/icons/trvto_copy.svg';
import Star from '../../../assets/icons/trvto_star.svg';
import Google from '../../../assets/icons/trvto_google.svg';
export default function OrgInfo({ accDetails, setModal }) {
    const getLink = (org) => {
        const link = `${window.location.origin}/h/orgid/${org._id}`;
        const copyToClipboard = () => {
            navigator.clipboard.writeText(link).then(() => {
                toast.success('Link copied to clipboard');
            });
        };

        return (
            <div className='alignCenter'>
                <span>{link}</span>
                <Copy className='cursor-pointer' onClick={copyToClipboard} />
            </div>
        );
    };

    return (
        <div>
            <div className='flex justify mb-2'>
                <h2 className='orgAccountH2Own'>Profile</h2>
                <button className='orgAccEditBtn blueBtn' onClick={() => setModal(true)}>
                    Edit
                </button>
            </div>
            <div className='orgAccountSecDiv'>
                <div className='profileDiv'>
                    <div className='orgLogoDiv'>
                        {accDetails?.logo && <img src={accDetails?.logo} width={120} height={50} alt='trvto_logo' />}
                    </div>
                    <div className='w-full'>
                        <div className='orgAccountInDiv'>
                            <div className='w-full'>
                                <div className='orgAccountGrid'>
                                    <FormContent
                                        id='orgExtraStyle'
                                        label='Company Name'
                                        answer={accDetails?.companyName}
                                        className='borderNone width50'
                                    />
                                    <FormContent
                                        id='orgExtraStyle'
                                        label='Type'
                                        answer={accDetails?.typeofCompany}
                                        className='borderNone width50'
                                    />
                                </div>
                            </div>
                            <div className='w-full'>
                                <div className='orgAccountGrid'>
                                    <FormContent
                                        id='orgExtraStyle'
                                        label='Email'
                                        answer={accDetails?.emailId}
                                        className='borderNone width50'
                                    />
                                    <FormContent
                                        id='orgExtraStyle'
                                        label='State'
                                        answer={`${accDetails?.address?.state} , ${accDetails?.address?.country}`}
                                        className='borderNone width50'
                                    />
                                </div>
                            </div>
                            <div className='w-full'>
                                <div className='orgAccountGrid'>
                                    <FormContent
                                        id='orgExtraStyle'
                                        label='Link'
                                        answer={getLink(accDetails)}
                                        className='borderNone width50'
                                    />
                                </div>
                            </div>
                            <div className='w-full' style={{ marginTop: '30px' }}>
                                <div className='orgAccountGrid'>
                                    <img
                                        src={Google}
                                        width={20}
                                        height={20}
                                        alt='Google Logo'
                                        style={{ marginRight: '10px' }}
                                    />
                                    <div>
                                        Rated{' '}
                                        <strong>
                                            {accDetails.googleRating}
                                            <img src={Star} width={15} height={15} alt='Star' />
                                        </strong>{' '}
                                        with <strong>{accDetails.googleRaCount}</strong> reviews on Google
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
